export default (() => {
    const items = Array.from(document.querySelectorAll('.js-overflow-screen'));

    items.forEach((el) => {
        el.addEventListener('toggledOn', () => document.body.classList.add('overflow-hidden'));
        el.addEventListener('toggledOff', () => document.body.classList.remove('overflow-hidden'));
    });
})();
